import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { withRouter } from "react-router-dom";
import { TransitionGroup, CSSTransition } from 'react-transition-group'
import moment from 'moment';
import axios from 'axios';
import Geocode from "react-geocode";
import { DateUtils } from 'react-day-picker';
import { RightSidebar } from './components/RightSidebar'; 
import Landing from './pages/Landing';
import VisitorQuestionnaire from './pages/VisitorQuestionnaire';
import WorkHistory from './pages/WorkHistory';
import OffenderToVisit from './pages/OffenderToVisit';
import SelectedOffenders from './pages/SelectedOffenders';
import VisitorOffenderRelationship from './pages/VisitorOffenderRelationship';
import ApplicantInfo from './pages/ApplicantInfo';
import ApplicantPhysical from './pages/ApplicantPhysical';
import ApplicantContact from './pages/ApplicantContact';
import AddMinor from './pages/AddMinor';
import MinorQuestionnaire from './pages/MinorQuestionnaire';
import MinorInfo from './pages/MinorInfo';
import MinorVisitSelection from './pages/MinorVisitSelection';
import MinorReview from './pages/MinorReview';
import ApplicationReview from './pages/ApplicationReview';
import ApplicationDeclined from './pages/ApplicationDeclined';
import ApplicationSubmitted from './pages/ApplicationSubmitted';
import { ProgressBar } from './components/ProgressBar';
import { StepCount } from './components/StepCount';
import formFields from './utils/formFields';
import minorFormFields from './utils/minorFormFields';
import { stepTracker } from './utils/stepTracker';
import usStateList from './utils/usStateList';
import { Countries } from './utils/countries';
import { facilities } from './utils/facilitiesList';
import { relationships } from './utils/relationshipList';

axios.post("VisitorApplication.aspx/GetGKey", {test: "test"})
  .then(res => {
    Geocode.setApiKey(res.data.d);
  })
  .catch(err => {
    console.log(err);
  })

class App extends Component {
  state = {
    stepTracker: stepTracker,
    heading: '',
    pageId: '',
    completedFormStep: 0,
    currentStep: 0,
    currentProgress: null,
    showProgressBar: false,
    badge: false,
    fields: formFields,
    declined: false,
    minorDeclined: false,
    currentMinor: null,
    minorCount: 0,
    selectedMinors: {},
    offenderIncrementer: 1,
    formIncomplete: true,
    submissionStatus: null,
    submissionStatusText: ""
  }
  componentDidUpdate = () => {
    if (this.state.formIncomplete) {
      window.onbeforeunload = (e) => true
    } else {
      window.onbeforeunload = undefined
    }
  }
  handleInputChange = (event) => {
    const target = event.target;
    const name = target.name;
    let value = target.type === 'checkbox' ? target.checked : target.value;
    if(target.type === 'tel') {
      value = this.fieldMask(event, [4,8], '-');
    }
    const field = this.state.fields[name];
    this.setState({
      fields: {
        ...this.state.fields,
        [name]:  {...field, value: value}
      }
    });
  }
  handleMinorInputChange = (event) => {
    const target = event.target;
    const name = target.name;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const currentMinor = this.state.currentMinor;
    const field = this.state.selectedMinors[currentMinor].fields[name];
    this.setState({
      selectedMinors: {
        ...this.state.selectedMinors,
        [currentMinor]: {
          ...this.state.selectedMinors[currentMinor],
          fields: {
            ...this.state.selectedMinors[currentMinor].fields,
            [name]:  {...field, value: value}
          }
        }
      }
    });
  }
  handleSliderChange = (range, minName, maxName) => {
    const rangeLow = range[0];
    const rangeHigh = range[1];
    this.setState({
      fields: {...this.state.fields,
        [minName]: {...this.state.fields[minName],
          value: rangeLow,
        },
        [maxName]: {...this.state.fields[maxName],
          value: rangeHigh,
        }
      }
    });
  }
  formatDate(date) {
    return moment(date).format('L');
  }
  parseDate(str, format, locale) {
    const parsed = new Date(str);
    if (DateUtils.isDate(parsed)) {
      return parsed;
    }
    return undefined;
  }
  handleDateInput = (date, name) => {
    const dateField = this.state.fields[name];
    this.setState({
      fields: {
        ...this.state.fields,
        [name]: {...dateField, value: date}
      }
    });
  }
  handleMinorDateInput = (date, name) => {
    const currentMinor = this.state.currentMinor;
    const dateField = this.state.selectedMinors[currentMinor].fields[name];
    this.setState({
      selectedMinors: {
        ...this.state.selectedMinors,
        [currentMinor]: {
          ...this.state.selectedMinors[currentMinor],
          fields: {
            ...this.state.selectedMinors[currentMinor].fields,
            [name]: {...dateField, value: date}
          }
        }
      }
    });
  }
  clearInput = (fieldName, cleared='') => {
    const field = this.state.fields[fieldName];

    this.setState({
      fields: {...this.state.fields,
        [fieldName]: {...field,
          value: cleared
        }
      }
    })
  }
  handleEmailAutocomplete = (fieldName, suffix) => {
    let value = this.state.fields[fieldName].value;
    const suffixStart = value.indexOf('@') + 1;

    if(suffixStart !==-1) {
      value = value.slice(0, suffixStart) + suffix;
    } 

    this.setState({
      fields: {
        ...this.state.fields,
        [fieldName]: {
          ...this.state.fields[fieldName],
          value: value
        }
      }
    });
  }
  handleZipcodeAutofill = (event, cityFieldName, stateFieldName, countryFieldName) => {
    const target = event.target;
    const name = target.name;
    const value = target.value;
    const field = this.state.fields[name];
    if((value.length === 5) && 
      (parseFloat(value) === parseInt(value,0)) && 
      !isNaN(value)) {
      this.getLocation(value, cityFieldName, stateFieldName, countryFieldName);
    }
    this.setState({
      fields: {
        ...this.state.fields,
        [name]:  {...field, value: value}
      }
    });
  }
  getLocation(zipcode, cityFieldName, stateFieldName, countryFieldName) {
    Geocode.fromAddress(zipcode).then(
      response => {  
        this.setCityState(response.results[0], cityFieldName, stateFieldName, countryFieldName); 
      },
      error => {
        console.error(error);
      }
    );
  }
  setCityState = (location, cityFieldName, stateFieldName, countryFieldName) => {
    let city, state, countryName, countryNumCode;
    const address = location.address_components;
    for (var i = 0; i < address.length; i++) {
      if(address[i].types.indexOf('locality') !== -1) {
        city = address[i].long_name;
      } else if(address[i].types.indexOf('administrative_area_level_1') !== -1) {
        state = address[i].long_name;
      } else if(address[i].types.indexOf('sublocality_level_1') !== -1 && (city === undefined)) {
        city = address[i].long_name;
      } else if(address[i].types.indexOf('country') !== -1) {
        countryName = address[i].long_name;
      }
    }

    if(countryName) {
      countryNumCode = Countries[countryName];
    }
    this.setState({
      fields: {
        ...this.state.fields,
        [cityFieldName]: {
          ...this.state.fields[cityFieldName],
          value: city
        },
        [stateFieldName]: {
          ...this.state.fields[stateFieldName],
          value: state
        },
        [countryFieldName]: {
          ...this.state.fields[countryFieldName],
          value: countryNumCode,
          countryName: countryName
        }
      }
    })
  }
  getStateNumCode(stateName) {
    let numCode;

    for (var i = 0; i < usStateList.length; i++) {
      if(usStateList[i].value === stateName) {
        numCode = usStateList[i].numCode;
      }
    }

    return numCode;
  }
  getCountryName(numCode) {
    let countryName;

    for(var country in Countries) {
      if (Countries[country] === numCode) {
        countryName = country;
      }
    }

    return countryName;
  }
  getOptionName(field, value) {
    let name;
    field.options.map(option => {
      if(option.value === value) {
        name = option.label;
      }
      return option;
    });
    return name;
  }
  fieldMask(event, maskPoints, maskChar) {
    var val = event.target.value;
    const key = val[val.length - 1];
    for(var i = 0; i < maskPoints.length; i++) {
        if (val.length === maskPoints[i] && event.key != maskChar && key != maskChar) {
            let arr = val.split('');
            arr[maskPoints[i] - 1] = maskChar;
            arr.push(key);
            val =  arr.join('');
        } 
    }
      return val;
  }
  saveOffender = (offender) => {
    const id = offender.OffenderId;
    const incrementerId = this.state.offenderIncrementer;
    this.setState({
      fields: {
        ...this.state.fields,
        selectedOffenders:{
          ...this.state.fields.selectedOffenders,
          [id]: {
            ...offender,
            RelationshipToVisitor: {
              value: '',
              className: '',
              errMessage: '',
              immediateFamily: true,
            },
            incrementerId: incrementerId
          }
        },
      },
      offenderIncrementer: this.state.offenderIncrementer + 1
    });
  }
  minorSaveOffender = (offender) => {
    const id = offender.OffenderId;
    const currentMinor = this.state.currentMinor;
    this.setState({
      selectedMinors: {
        ...this.state.selectedMinors,
        [currentMinor]: {
          ...this.state.selectedMinors[currentMinor],
          selectedOffenders: {
            ...this.state.selectedMinors[currentMinor].selectedOffenders,
            [id]:  {
              ...offender, 
              RelationshipToMinor: {
                value: '',
                className: '',
                errMessage: '',
                immediateFamily: true,
              }
            }
          }
        }
      }
    });
  }
  removeMinorOffender = (offenderId) => {
    const currentMinor = this.state.currentMinor;
    delete this.state.selectedMinors[currentMinor].selectedOffenders[offenderId];
    this.setState({
      selectedMinors: {
        ...this.state.selectedMinors,
        [currentMinor]: {
          ...this.state.selectedMinors[currentMinor],
          selectedOffenders: {...this.state.selectedMinors[currentMinor].selectedOffenders}
        }
      }
    });
  }
  handleMinorOffenderSelectionInput = (event) => {
    const target = event.target;
    const offenderId = target.name
    const offender = this.state.fields.selectedOffenders[offenderId]
    if(target.checked) {
      this.minorSaveOffender(offender);
    } else {
      this.removeMinorOffender(offenderId);
    }
  }
  setOffenderRelationship = (event) => {
    const {name, value} = event.target;
    let immediateFamily = true;
    const data = event.target.options[event.target.selectedIndex].getAttribute('data');
    immediateFamily = data !== "immediate" ?  false : immediateFamily;
    const selectedOffenders = this.state.fields.selectedOffenders;
    const offenderToUpdate = selectedOffenders[name];
    this.setState({
      fields: {
        ...this.state.fields,
        selectedOffenders:  {
          ...selectedOffenders, 
          [name]: {
            ...offenderToUpdate,
            RelationshipToVisitor: {
              value: value,
              immediateFamily: immediateFamily,
              errMessage: '',
              className: '',
            }
          }
        }
      }
    });
  }
  setMinorOffenderRelationship = (event) => {
    const {name, value} = event.target;
    let immediateFamily = false;
    const data = event.target.options[event.target.selectedIndex].getAttribute('data');
    immediateFamily = data === "immediate" ? true : immediateFamily;
    const currentMinor = this.state.currentMinor;
    const selectedOffenders = this.state.selectedMinors[currentMinor].selectedOffenders;
    const offenderToUpdate = selectedOffenders[name];
    this.setState({
      selectedMinors: {
        ...this.state.selectedMinors,
        [currentMinor]: {
          ...this.state.selectedMinors[currentMinor],
          selectedOffenders:  {
            ...selectedOffenders, 
            [name]: {
              ...offenderToUpdate,
              RelationshipToMinor: {
                value: value,
                immediateFamily: immediateFamily,
                errMessage: '',
                className: '',
              }
            }
          }
        }
      }
    });
  }
  validateRelationshipFields = () => {
    let isErr = false;
    const selectedOffenders = this.state.fields.selectedOffenders
    const offenderIds = Object.keys(selectedOffenders);
    let errMessage = '';
    let className = '';
    offenderIds.map(id => {
      const offender = selectedOffenders[id]
      if(!offender.RelationshipToVisitor.value){
        isErr=true;
        errMessage = 'Please select one';
        className = 'input-err';
      }
      this.state.fields.selectedOffenders[id].RelationshipToVisitor.errMessage = errMessage;
      this.state.fields.selectedOffenders[id].RelationshipToVisitor.className = className;
      return id;
    })
    this.setState({
      fields: {
        ...this.state.fields,
        selectedOffenders: this.state.fields.selectedOffenders
      }
    });
    return isErr;
  }
  validateMinorRelationshipFields = () => {
    let isErr = false;
    const currentMinor = this.state.currentMinor;
    const selectedOffenders = this.state.selectedMinors[currentMinor].selectedOffenders
    const offenderIds = Object.keys(selectedOffenders);
    offenderIds.map(id => {
      let errMessage = '';
      let className = '';
      const offender = selectedOffenders[id]
      if(!offender.RelationshipToMinor.value){
        isErr=true;
        errMessage = 'Please select one';
        className = 'input-err';
      }
      selectedOffenders[id].RelationshipToMinor.errMessage = errMessage;
      selectedOffenders[id].RelationshipToMinor.className = className;
      return id;
    })
    this.setState({
      selectedMinors: {
        ...this.state.selectedMinors,
        [currentMinor]: {
          ...this.state.selectedMinors[currentMinor],
          selectedOffenders: selectedOffenders
        }
      }
    });
    return isErr;
  }
  removeSelectedOffender = (offenderId) => {
    delete this.state.fields.selectedOffenders[offenderId];
    this.setState({
      fields: {
        ...this.state.fields,
        selectedOffenders: this.state.fields.selectedOffenders
      },
    });
    this.updateMinorOffenders(offenderId);
  }
  updateMinorOffenders = (offenderId) => {
    for(var minor in  this.state.selectedMinors) {
      const currentMinor = this.state.selectedMinors[minor];
      if(currentMinor.selectedOffenders && currentMinor.selectedOffenders[offenderId]) {
        delete this.state.selectedMinors[minor].selectedOffenders[offenderId];
      }
    }
    for(var fieldsMinor in  this.state.fields.selectedMinors) {
      const currentMinor = this.state.fields.selectedMinors[fieldsMinor];
      if(currentMinor.selectedOffenders && currentMinor.selectedOffenders[offenderId]) {
        delete this.state.fields.selectedMinors[fieldsMinor].selectedOffenders[offenderId];
      }
    }
    this.setState({
      fields: {
        ...this.state.fields,
        selectedMinors: this.state.fields.selectedMinors
      },
      selectedMinors: {
        ...this.state.selectedMinors  
      }
    });
  }
  addMinor = () => {
    const minorId = this.state.minorCount;
    this.setState({
      selectedMinors: {
        ...this.state.selectedMinors,
        [minorId]: {
          fields: minorFormFields,
          selectedOffenders: {}
        },
      },
      fields: {
        ...this.state.fields,
        minorCertification: {
          ...this.state.fields.minorCertification,
          value: true,
        }
      }, 
      currentMinor: minorId,
      minorCount: minorId + 1
    });
    //console.log('AddMinor', this.state.selectedMinors)
  }
  validateStep = (fields) => {
    const self = this;
    let isErr = false;
    let declined = false;
    fields.map(fieldName => {
      const field = self.state.fields[fieldName];
      const val = field.value || '';
      const isRequired = field.isRequired || false;
      let errMessage = field.validation(val, isRequired);

      if(!(errMessage)) {
        errMessage = '';
        field.className = '';
      } else {
        isErr = true;
        field.className = 'input-err';
      }
      if(field.fatal && field.value === field.fatalVal) {
        declined = true;
        isErr = true;
      }
      field.errMessage = errMessage;
      return field;
    })

    if(declined) {
      this.handleDeclined();
    } 

    this.setState({fields: this.state.fields});
    return isErr;
  }
  validateMinorStep = (fields) => {
    const self = this;
    const currentMinor = this.state.currentMinor;
    let isErr = false;
    let declined = false;
    if(self.state.selectedMinors[currentMinor]) {
      fields.map(fieldName => {
        const field = self.state.selectedMinors[currentMinor].fields[fieldName];
        const val = field.value || '';
        const isRequired = field.isRequired || false;
        let errMessage = field.validation(val, isRequired);

        if(!(errMessage)) {
          errMessage = '';
          field.className = '';
        } else {
          isErr = true;
          field.className = 'input-err';
        }
        if(field.fatal && field.value === field.fatalVal) {
          declined = true;
          isErr = true;
        }
        field.errMessage = errMessage;
        return field;
      })
      this.setState({
        selectedMinors: {
          ...this.state.selectedMinors,
          [currentMinor]: {
            ...this.state.selectedMinors[currentMinor],
            fields: {
              ...this.state.selectedMinors[currentMinor].fields
            }
          }
        }
      });
    }

    if(declined) {
      this.handleDeclined(true);
    } 
    return isErr;
  }
  scrollToError() {
    const errorFields = document.getElementsByClassName('input-err');
    if(errorFields.length > 0) {
      errorFields[0].scrollIntoView();
    }
  }
  clearErrors = (fields) => {
    const self = this;
    fields.map(fieldName => {
      const field = self.state.fields[fieldName];
      field.errMessage = '';
      field.className = '';
      return fieldName;
    });
    this.setState({fields: this.state.fields});
  }
  previousStep = (currentStep) => {
    const stepTracker = this.state.stepTracker;
    let prevStep;
    currentStep.altBack ? 
      prevStep = stepTracker[currentStep.altPrevStep] :
      prevStep = stepTracker[currentStep.prevStep];
    const prevUrl = prevStep.url;
    this.props.history.push(prevUrl);
  }
  nextStep = (currentStep) => {
    const stepTracker = this.state.stepTracker;
    const stepKey = currentStep.step;
    let nextStep;
    currentStep.altForward ? 
      nextStep = stepTracker[currentStep.altNextStep] :
      nextStep = stepTracker[currentStep.nextStep];
    const nextStepKey = nextStep.step;
    const nextUrl = nextStep.url;
    this.setState({
      stepTracker: {
        ...stepTracker, 
        [stepKey]: currentStep,
        [nextStepKey]: {
          ...nextStep,
          access: true 
        }
      },
    });
    this.props.history.push(nextUrl)
  }
  handleDeclined = (isMinorDeclined = false) => {
    if(isMinorDeclined) {
      const currentMinor = this.state.currentMinor;
      delete this.state.selectedMinors[currentMinor];
      this.setState({
        minorDeclined: true,
        currentMinor: null,
        selectedMinors: this.state.selectedMinors,
      }); 
    } else {
      this.setState({declined: true});
    }
    this.props.history.push('/application-declined');
  }
  setHeaderDisplay = (heading, currentStep, showProgressBar, pageId, progress, badge = false) => {
    this.setState({
      heading: heading,
      currentStep: currentStep,
      currentProgress: progress,
      showProgressBar: showProgressBar,
      badge: badge,
      pageId: pageId,
    });
  }
  handleSubmitApplication = () => {
    var formattedData = this.handleFormatData(this.state.fields);
    var payload = {submission:formattedData}
    console.log(payload)
    //SESC Server Post
    const apiUrl = 'VisitorApplication.aspx/SubmitReactVisitationForm';
    axios.post(apiUrl, payload)
      .then(res => {
        this.setState({
          submissionStatus: res.data.d.StatusCode,
          submissionStatusText: res.data.d.ReasonPhrase,
        });
        this.props.history.push('application-submitted');
      })
      .catch(err => {
        this.props.history.push('application-submitted');
      });
  } 
  handleFormatData = (fields) => {
    var formattedData = {
      VADOCEmployee: fields.VADOCEmployee.value,
      ActiveParole: fields.activeParole.value,
      ApplicantCity: fields.applicantCity.value,
      ApplicantCountryCode: fields.applicantCountry.value,
      ApplicantDOB: fields.applicantDOB.value,
      ApplicantPlaceOfBirth: fields.applicantPlaceOfBirth.value,
      ApplicantEmail: fields.applicantEmail.value,
      ApplicantEyes: fields.applicantEyes.value,
      ApplicantHair: fields.applicantHair.value,
      ApplicantVisitationType: fields.applicantVisitationType.value,
      ApplicantHeightFt: fields.applicantHeightFt.value,
      ApplicantHeightIn: fields.applicantHeightIn.value,
      ApplicantIdNumber: fields.applicantIdNumber.value,
      ApplicantIdType: fields.applicantIdType.value,
      ApplicantPhone: fields.applicantPhone.value,
      ApplicantPhoneType: fields.applicantPhoneType.value,
      ApplicantRace: fields.applicantRace.value,
      ApplicantSex: fields.applicantSex.value,
      ApplicantSsn: fields.applicantSsn.value,
      ApplicantState: fields.applicantState.value,
      ApplicantStreet: fields.applicantStreet.value,
      ApplicantWeight: fields.applicantWeight.value,
      ApplicantZip: fields.applicantZip.value,
      FelonyConviction: fields.felonyConviction.value,
      GangAssociation: fields.gangAssociation.value,
      ProtectiveOrder: fields.protectiveOrder.value,
      LegalFirstName: fields.firstName.value,
      LegalLastName: fields.lastName.value,
      LegalMiddleName: fields.middleName.value,
      MinorCertification: fields.minorCertification.value,
      FinalAuthorization: fields.finalAuthorization.value,
      SelectedOffendersJson: [],
      SelectedMinorsJson: []
    }
    //Format selected offenders
    for(var offender in this.state.fields.selectedOffenders) {
      var selectedOffender = this.state.fields.selectedOffenders[offender];
      const facilityName = selectedOffender.LocationName;
      let relQualifier;
      let relType;
      const relationshipFormat = this.formatRelationship(selectedOffender.RelationshipToVisitor.value);
      if(relationshipFormat) {
        relQualifier = relationshipFormat.qualifier;
        relType = relationshipFormat.type;
      } else {
        relQualifier = null;
        relType = selectedOffender.RelationshipToVisitor.value;
      }
      let facilityNum;
      if(facilities[facilityName]) {
        facilityNum = facilities[facilityName];
      } else {
        facilityNum = "9999";
      }
      var offenderObj = {
        Id: selectedOffender.incrementerId,
        Name: selectedOffender.FullName,
        Number: selectedOffender.OffenderId,
        Facility: facilityNum,
        FacilityName: facilityName,
        ContactType: selectedOffender.RelationshipToVisitor.immediateFamily ? "13" : "6",
        RelationshipType: relType,
        RelationshipQualifier: relQualifier,
        RelationshipName: relationships[selectedOffender.RelationshipToVisitor.value]
      }
      formattedData.SelectedOffendersJson.push(offenderObj);
    }

    // Stringify selected offenders
    formattedData.SelectedOffendersJson = JSON.stringify(formattedData.SelectedOffendersJson);

    // Format Selected Minors
    let minorIncrementer = 2;
    for(var minorVisitor in this.state.selectedMinors) {
      var selectedMinor = this.state.selectedMinors[minorVisitor];
      
      for(var offenderId in selectedMinor.selectedOffenders) {
        var currentOffender = selectedMinor.selectedOffenders[offenderId];
        let relQualifier;
        let relType;
        const relationshipFormat = this.formatRelationship(currentOffender.RelationshipToMinor.value);
        const raceName = this.getOptionName(selectedMinor.fields.race, selectedMinor.fields.race.value)
        const genderName = this.getOptionName(selectedMinor.fields.sex, selectedMinor.fields.sex.value)
        if(relationshipFormat) {
          relQualifier = relationshipFormat.qualifier;
          relType = relationshipFormat.type;
        } else {
          relQualifier = null;
          relType = currentOffender.RelationshipToMinor.value;
        }

        var minorObj = {
          Id: minorIncrementer,
          OffenderId: currentOffender.incrementerId,
          FirstName: selectedMinor.fields.firstName.value,
          MiddleName: selectedMinor.fields.middleName.value,
          LastName: selectedMinor.fields.lastName.value,
          Ssn: selectedMinor.fields.ssn.value,
          Race: selectedMinor.fields.race.value,
          RaceName: raceName,
          Gender: selectedMinor.fields.sex.value,
          GenderName: genderName,
          DOB: moment(selectedMinor.fields.DOB.value).format('MMM DD, YYYY'),
          MonthDob: moment(selectedMinor.fields.DOB.value).format('MM'),
          DayDob: moment(selectedMinor.fields.DOB.value).format('DD'),
          YearDob: moment(selectedMinor.fields.DOB.value).format('YYYY'),
          PlaceOfBirth: selectedMinor.fields.placeOfBirth.value,
          ContactType: currentOffender.RelationshipToMinor.immediateFamily ? "13" : "6",
          RelationshipType: relType,
          RelationshipQualifier: relQualifier,
          RelationshipName: relationships[currentOffender.RelationshipToMinor.value],
          ConvictedFelon: selectedMinor.fields.felonyConviction.value,
          UnderActiveSupervision: selectedMinor.fields.courtSupervision.value,
          VictimOfCurrentCrime: selectedMinor.fields.victimOfOffender.value,
          GangAssociation: selectedMinor.fields.gangAssociation.value,
          ParentLegalGuardian: selectedMinor.fields.parentLegalGuardian.value,
          minorCertification: fields.minorCertification.value,
        }

        formattedData.SelectedMinorsJson.push(minorObj);
        minorIncrementer += 1;  
      }
    }
    //Stringify SelectedMinorsJson 
    formattedData.SelectedMinorsJson = JSON.stringify(formattedData.SelectedMinorsJson);
    // Add non-required fields 
    if(fields.VADOCId.value) {
      formattedData["VADOCId"] = fields.VADOCId.value
    }
    if(fields.applicantState.value) {
      const stateName = fields.applicantState.value;
      formattedData["ApplicantStateNumCode"] = this.getStateNumCode(stateName);
    }
    if(fields.applicantCountry.value) {
      const numCode = fields.applicantCountry.value;
      const countryName = this.getCountryName(numCode);
      formattedData["ApplicantCountryName"] = countryName;
    }
    if(fields.applicantRace.value) {
      const raceName = this.getOptionName(fields.applicantRace, fields.applicantRace.value)
      formattedData["ApplicantRaceName"] = raceName;
    }
    if(fields.applicantSex.value) {
      const sexName = this.getOptionName(fields.applicantSex, fields.applicantSex.value)
      formattedData["ApplicantSexName"] = sexName;
    }
    if(fields.applicantVisitationType.value) {
      const visitTypeName = this.getOptionName(fields.applicantVisitationType, fields.applicantVisitationType.value)
      formattedData["ApplicantVistationTypeName"] = visitTypeName;
    }
    if(fields.applicantHair.value) {
      const hairName = this.getOptionName(fields.applicantHair, fields.applicantHair.value)
      formattedData["ApplicantHairName"] = hairName;
    }
    if(fields.applicantEyes.value) {
      const eyesName = this.getOptionName(fields.applicantEyes, fields.applicantEyes.value)
      formattedData["ApplicantEyesName"] = eyesName;
    }
    if(fields.applicantPhoneType.value) {
      const phoneName = this.getOptionName(fields.applicantPhoneType, fields.applicantPhoneType.value)
      formattedData["ApplicantPhoneTypeAlias"] = phoneName;
    }
    if(fields.applicantIdType.value) {
      const idName = this.getOptionName(fields.applicantIdType, fields.applicantIdType.value)
      formattedData["ApplicantIdTypeAlias"] = idName;
    }
    if(fields.ppDistrict.value) {
      formattedData["PpDistrict"] = fields.ppDistrict.value
    }
    if(fields.eligibleRehire.value) {
      formattedData["ApplicantRehire"] = fields.eligibleRehire.value
    }
    if(fields.employmentAlias.value) {
      formattedData["ApplicantAlias"] = fields.employmentAlias.value
    }
    if(fields.employmentLocation.value) {
      formattedData["EmploymentLocation"] = fields.employmentLocation.value
    }
    if(fields.employmentStartDate.value) {
      formattedData["EmploymentStartDate"] = fields.employmentStartDate.value
    }
    if(fields.employmentEndDate.value) {
      formattedData["EmploymentEndDate"] = fields.employmentEndDate.value
    }
    if(fields.employmentStatus.value) {
      formattedData["EmploymentStatus"] = fields.employmentStatus.value
    }
    if(fields.employmentTitle.value) {
      formattedData["EmploymentTitle"] = fields.employmentTitle.value
    }
    if(fields.employmentAlias.value) {
      formattedData["EmploymentAlias"] = fields.employmentAlias.value
    }
    if(fields.maidenName.value) {
      formattedData["LegalMaidenName"] = fields.maidenName.value
    }
    if(fields.meetOffender.value) {
      formattedData["MeetOffender"] = fields.meetOffender.value
    }
    if(fields.otherName.value) {
      formattedData["Alias"] = fields.otherName.value
    }

    return formattedData;
  }
  
  formatRelationship = (relationship) => {
    let formattedRelationship = null;
    switch(parseInt(relationship)) {
      // Father-in-law
      case 300:
        formattedRelationship = {
          qualifier: 6,
          type: 6
        }
        break;
      // Mother-in-law
      case 301:
        formattedRelationship = {
          qualifier: 6,
          type: 14
        }
        break;
      // Brother-in-law
      case 302:
        formattedRelationship = {
          qualifier: 6,
          type: 3
        }
        break;
      // Sister-in-law
      case 303:
        formattedRelationship = {
          qualifier: 6,
          type: 12
        }
        break;
      // Stepfather
      case 400:
        formattedRelationship = {
          qualifier: 4,
          type: 6
        }
        break;
      // Stepmother
      case 401:
        formattedRelationship = {
          qualifier: 4,
          type: 14
        }
        break;
      //Stepbrother
      case 402:
        formattedRelationship = {
          qualifier: 4,
          type: 3
        }
        break;
      //Stepsister
      case 403:
        formattedRelationship = {
          qualifier: 4,
          type: 12
        }
        break;
      default:
        formattedRelationship = null;
    }
    return formattedRelationship;
  }
  setCurrentMinor = (minorId) => {
    this.setState({currentMinor: minorId});
  }
  render() {
    const fields = this.state.fields;
    const currentMinor = this.state.selectedMinors[this.state.currentMinor];
    let minorFields;
    let minorSelectedOffenders;
    currentMinor ? minorFields = currentMinor.fields : minorFields = minorFormFields;
    currentMinor ? minorSelectedOffenders = currentMinor.selectedOffenders : minorSelectedOffenders = {};
    const showProgressBar = this.state.showProgressBar;
    const currentKey= this.state.pageId;
    const timeout = { enter: 800, exit: 100 }
    //console.log("fields",fields);
    return (
        <TransitionGroup component="div">
          <CSSTransition key={currentKey} timeout={timeout} classNames="fade" appear>
            <div className='relative-container'> 
              {showProgressBar ? (
                <ProgressBar 
                  width={(this.state.currentProgress / 15) * 100}
                  badge={this.state.badge} />
                ) : (false)
              }
              <main id={this.state.pageId} className="content-wrapper">
                {this.state.currentStep ? (
                  <StepCount step={this.state.currentStep} />
                  ) : (false)
                }
                {this.state.heading ? (
                  <h2>{this.state.heading}</h2>
                ) : false }
                <Switch>
                  <Route exact path="/" render={(routeProps) => (
                    <Landing {...routeProps}
                      nextStep={this.nextStep}
                      setHeaderDisplay={this.setHeaderDisplay}stepData={this.state.stepTracker[0]} />
                  )} />
                  <Route
                    exact path="/visitor-questionnaire"
                    render={(routeProps) => (
                      <VisitorQuestionnaire {...routeProps}
                        declined={this.state.declined}
                        handleDeclined={this.handleDeclined}
                        previousStep={this.previousStep}
                        nextStep={this.nextStep}
                        fields={{
                          VADOCEmployee: fields.VADOCEmployee,
                          activeParole: fields.activeParole,
                          felonyConviction: fields.felonyConviction,
                          protectiveOrder: fields.protectiveOrder,
                          gangAssociation: fields.gangAssociation,
                          applicantVisitationType: fields.applicantVisitationType
                        }}
                        conditionalFields={{
                          VADOCId: fields.VADOCId,
                          ppDistrict: fields.ppDistrict,
                        }}
                        validateStep={this.validateStep}
                        stepData={this.state.stepTracker[1]}
                        handleInputChange={this.handleInputChange}
                        setHeaderDisplay={this.setHeaderDisplay} />
                    )}
                  />
                  <Route
                    exact path="/work-history"
                    render={(routeProps) => (
                      <WorkHistory {...routeProps}
                        declined={this.state.declined}
                        handleDeclined={this.handleDeclined}
                        previousStep={this.previousStep}
                        nextStep={this.nextStep}
                        fields={{
                          eligibleRehire: fields.eligibleRehire,
                          meetOffender: fields.meetOffender,
                          employmentStatus: fields.employmentStatus,
                          employmentStartDate: fields.employmentStartDate,
                          employmentEndDate: fields.employmentEndDate,
                          employmentTitle: fields.employmentTitle,
                          employmentAlias: fields.employmentAlias,
                          employmentLocation: fields.employmentLocation
                        }}
                        validateStep={this.validateStep}
                        handleInputChange={this.handleInputChange}
                        handleDateInput={this.handleDateInput}
                        formatDate={this.formatDate}
                        parseDate={this.parseDate}
                        stepData={this.state.stepTracker[2]}
                        setHeaderDisplay={this.setHeaderDisplay} />
                    )}
                  />
                  <Route
                    exact path="/who-to-visit"
                    render={(routeProps) => (
                      <OffenderToVisit {...routeProps}
                        declined={this.state.declined}
                        handleDeclined={this.handleDeclined}
                        previousStep={this.previousStep}
                        nextStep={this.nextStep}
                        fields={{
                          offenderSearchFirstName: fields.offenderSearchFirstName,
                          offenderSearchLastName: fields.offenderSearchLastName,
                          offenderSearchId: fields.offenderSearchId,
                          offenderSearchMiddleName: fields.offenderSearchMiddleName,
                          offenderSearchReleaseDate: fields.offenderSearchReleaseDate,
                          offenderSearchAlias: fields.offenderSearchAlias,
                          offenderSearchRace: fields.offenderSearchRace,
                          offenderSearchSex: fields.offenderSearchSex,
                          offenderSearchAgeFrom: fields.offenderSearchAgeFrom,
                          offenderSearchAgeTo: fields.offenderSearchAgeTo,
                        }}
                        validateStep={this.validateStep}
                        clearErrors={this.clearErrors}
                        clearInput={this.clearInput}
                        handleInputChange={this.handleInputChange}
                        handleDateInput={this.handleDateInput}
                        formatDate={this.formatDate}
                        parseDate={this.parseDate}
                        getOptionName={this.getOptionName}
                        saveOffender={this.saveOffender}
                        handleSliderChange={this.handleSliderChange}
                        stepData={this.state.stepTracker[3]}
                        setHeaderDisplay={this.setHeaderDisplay} />
                    )}
                  />
                  <Route
                    exact path="/visitor-offender-relationship"
                    render={(routeProps) => (
                      <VisitorOffenderRelationship {...routeProps}
                        declined={this.state.declined}
                        handleDeclined={this.handleDeclined}
                        previousStep={this.previousStep}
                        nextStep={this.nextStep}
                        fields={{
                          selectedOffenders: fields.selectedOffenders,
                        }}
                        validateRelationshipFields={this.validateRelationshipFields}
                        validateStep={this.validateStep}
                        handleInputChange={this.setOffenderRelationship}
                        removeSelectedOffender={this.removeSelectedOffender}
                        stepData={this.state.stepTracker[4]}
                        setHeaderDisplay={this.setHeaderDisplay} />
                    )}
                  />
                  <Route
                    exact path="/selected-offenders"
                    render={(routeProps) => (
                      <SelectedOffenders {...routeProps}
                        declined={this.state.declined}
                        handleDeclined={this.handleDeclined}
                        previousStep={this.previousStep}
                        nextStep={this.nextStep}
                        fields={{
                          selectedOffenders: fields.selectedOffenders
                        }}
                        removeSelectedOffender={this.removeSelectedOffender}
                        handleStepSubmit={this.handleStepSubmit}
                        handleInputChange={this.handleInputChange}
                        setHeaderDisplay={this.setHeaderDisplay}
                        stepData={this.state.stepTracker[5]} />
                    )}
                  />
                  <Route
                    exact path="/applicant-information"
                    render={(routeProps) => (
                      <ApplicantInfo {...routeProps}
                        declined={this.state.declined}
                        handleDeclined={this.handleDeclined}
                        nextStep={this.nextStep}
                        previousStep={this.previousStep}
                        fields={{
                          applicantDOB: fields.applicantDOB,
                          applicantPlaceOfBirth: fields.applicantPlaceOfBirth,
                          firstName: fields.firstName,
                          middleName: fields.middleName,
                          lastName: fields.lastName,
                          maidenName: fields.maidenName,
                          otherName: fields.otherName,
                          applicantIdType: fields.applicantIdType,
                          applicantIdNumber: fields.applicantIdNumber,
                          applicantSsn: fields.applicantSsn
                        }}
                        validateStep={this.validateStep}
                        handleStepSubmit={this.handleStepSubmit}
                        handleInputChange={this.handleInputChange}
                        handleDateInput={this.handleDateInput}
                        formatDate={this.formatDate}
                        parseDate={this.parseDate}
                        stepData={this.state.stepTracker[6]}
                        setHeaderDisplay={this.setHeaderDisplay} />
                    )}
                  />
                  <Route
                    exact path="/applicant-physical"
                    render={(routeProps) => (
                      <ApplicantPhysical {...routeProps}
                        declined={this.state.declined}
                        handleDeclined={this.handleDeclined}
                        nextStep={this.nextStep}
                        previousStep={this.previousStep}
                        fields={{
                          applicantRace: fields.applicantRace,
                          applicantSex: fields.applicantSex,
                          applicantHair: fields.applicantHair,
                          applicantEyes: fields.applicantEyes,
                          applicantHeightFt: fields.applicantHeightFt,
                          applicantHeightIn: fields.applicantHeightIn,
                          applicantWeight: fields.applicantWeight,
                        }}
                        validateStep={this.validateStep}
                        handleStepSubmit={this.handleStepSubmit}
                        handleInputChange={this.handleInputChange}
                        stepData={this.state.stepTracker[7]}
                        setHeaderDisplay={this.setHeaderDisplay} />
                    )}
                  />
                  <Route
                    exact path="/applicant-contact"
                    render={(routeProps) => (
                      <ApplicantContact {...routeProps}
                        declined={this.state.declined}
                        handleDeclined={this.handleDeclined}
                        nextStep={this.nextStep}
                        previousStep={this.previousStep}
                        fields={{
                          applicantCountry: fields.applicantCountry,
                          applicantStreet: fields.applicantStreet,
                          applicantZip: fields.applicantZip,
                          applicantCity: fields.applicantCity,
                          applicantState: fields.applicantState,
                          applicantEmail: fields.applicantEmail,
                          applicantPhone: fields.applicantPhone,
                          applicantPhoneType: fields.applicantPhoneType,
                        }}
                        validateStep={this.validateStep}
                        handleInputChange={this.handleInputChange}
                        handleEmailAutocomplete={this.handleEmailAutocomplete}
                        handleZipcodeAutofill={this.handleZipcodeAutofill}
                        stepData={this.state.stepTracker[8]}
                        setHeaderDisplay={this.setHeaderDisplay} />
                    )}
                  />
                  <Route
                    exact path="/add-minor"
                    render={(routeProps) => (
                      <AddMinor {...routeProps}
                        declined={this.state.declined}
                        handleDeclined={this.handleDeclined}
                        nextStep={this.nextStep}
                        previousStep={this.previousStep}
                        fields={{
                          minorCertification: fields.minorCertification
                        }}
                        addMinor={this.addMinor}
                        validateStep={this.validateStep}
                        handleStepSubmit={this.handleStepSubmit}
                        handleInputChange={this.handleInputChange}
                        stepData={this.state.stepTracker[9]}
                        setHeaderDisplay={this.setHeaderDisplay} />
                    )}
                  />
                  <Route
                    exact path="/minor-questionnaire"
                    render={(routeProps) => (
                      <MinorQuestionnaire {...routeProps}
                        declined={this.state.declined}
                        handleDeclined={this.handleDeclined}
                        nextStep={this.nextStep}
                        previousStep={this.previousStep}
                        fields={{
                          victimOfOffender: minorFields.victimOfOffender,
                          felonyConviction: minorFields.felonyConviction,
                          courtSupervision: minorFields.courtSupervision,
                          gangAssociation: minorFields.gangAssociation
                        }}
                        validateStep={this.validateMinorStep}
                        handleInputChange={this.handleMinorInputChange}
                        stepData={this.state.stepTracker[10]}
                        setHeaderDisplay={this.setHeaderDisplay} />
                    )}
                  />
                  <Route
                    exact path="/minor-information"
                    render={(routeProps) => (
                      <MinorInfo {...routeProps}
                        declined={this.state.declined}
                        handleDeclined={this.handleDeclined}
                        nextStep={this.nextStep}
                        previousStep={this.previousStep}
                        fields={{
                          DOB: minorFields.DOB,
                          firstName: minorFields.firstName,
                          middleName: minorFields.middleName,
                          lastName: minorFields.lastName,
                          ssn: minorFields.ssn,
                          placeOfBirth: minorFields.placeOfBirth,
                          race: minorFields.race,
                          sex: minorFields.sex
                        }}
                        handleDateInput={this.handleMinorDateInput}
                        formatDate={this.formatDate}
                        parseDate={this.parseDate}
                        validateStep={this.validateMinorStep}
                        handleInputChange={this.handleMinorInputChange}
                        stepData={this.state.stepTracker[11]}
                        setHeaderDisplay={this.setHeaderDisplay} />
                    )}
                  />
                  <Route
                    exact path="/minor-visit-selection"
                    render={(routeProps) => (
                      <MinorVisitSelection {...routeProps}
                        declined={this.state.declined}
                        handleDeclined={this.handleDeclined}
                        nextStep={this.nextStep}
                        previousStep={this.previousStep}
                        fields={{
                          selectedOffenders: fields.selectedOffenders,
                          minorSelectedOffenders: minorSelectedOffenders,
                          currentMinor: this.state.selectedMinors[this.state.currentMinor]
                        }}
                        validateStep={this.validateMinorStep}
                        handleAddOffender={this.handleMinorOffenderSelectionInput}
                        setMinorOffenderRelationship={this.setMinorOffenderRelationship}
                        validateMinorRelationshipFields={this.validateMinorRelationshipFields}
                        stepData={this.state.stepTracker[12]}
                        setHeaderDisplay={this.setHeaderDisplay} />
                    )}
                  />
                  <Route
                    exact path="/review-minor"
                    render={(routeProps) => (
                      <MinorReview {...routeProps}
                        declined={this.state.declined}
                        handleDeclined={this.handleDeclined}
                        fields={{
                          selectedMinors: this.state.selectedMinors,
                        }}
                        nextStep={this.nextStep}
                        previousStep={this.previousStep}
                        setCurrentMinor={this.setCurrentMinor}
                        getOptionName={this.getOptionName}
                        validateStep={this.validateMinorStep}
                        stepData={this.state.stepTracker[13]}
                        setHeaderDisplay={this.setHeaderDisplay} />
                    )}
                  />
                  <Route
                    exact path="/application-review"
                    render={(routeProps) => (
                      <ApplicationReview {...routeProps}
                        declined={this.state.declined}
                        handleDeclined={this.handleDeclined}
                        getOptionName={this.getOptionName}
                        fields={{
                          visitorFields: fields,
                          selectedOffenders: fields.selectedOffenders,
                          selectedMinors: this.state.selectedMinors,
                          finalAuthorization: fields.finalAuthorization,
                        }}
                        fatalApplicantFields = {{
                          felonyConviction: fields.felonyConviction,
                          protectiveOrder: fields.protectiveOrder,
                          gangAssociation: fields.gangAssociation
                        }} 
                        nonFatalApplicantFields = {[
                          "firstName",
                          "lastName",
                          "middleName",
                          "otherName",
                          "applicantIdNumber",
                          "applicantSsn",
                          "applicantRace",
                          "applicantSex",
                          "applicantHeightFt",
                          "applicantHeightIn",
                          "applicantWeight"
                        ]}
                        previousStep={this.previousStep}
                        handleInputChange={this.handleInputChange}
                        validateStep={this.validateStep}
                        validateMinorStep={this.validateMinorStep}
                        setCurrentMinor={this.setCurrentMinor}
                        currentMinor={this.state.currentMinor}
                        stepData={this.state.stepTracker[14]} 
                        setHeaderDisplay={this.setHeaderDisplay} 
                        handleSubmitApplication={this.handleSubmitApplication} />
                    )}
                  />
                  <Route
                    exact path="/application-submitted"
                    render={(routeProps) => (
                      <ApplicationSubmitted {...routeProps}
                        declined={this.state.declined}
                        stepData={this.state.stepTracker[14]}
                        previousStep={this.previousStep}
                        setHeaderDisplay={this.setHeaderDisplay} 
                        submissionStatus={this.state.submissionStatus}
                        submissionStatusText={this.state.submissionStatusText} />
                    )}
                  />
                  <Route
                    exact path="/application-declined"
                    render={(routeProps) => (
                      <ApplicationDeclined {...routeProps}
                        minorDeclined={this.state.minorDeclined}
                        declined={this.state.declined}
                        stepData={this.state.stepTracker[16]}
                        previousStep={this.previousStep}
                        clearForm={this.clearForm}
                        nextStep={this.nextStep}
                        setHeaderDisplay={this.setHeaderDisplay} />
                    )}
                  />
                </Switch>
              </main>
              <RightSidebar />
            </div>
            </CSSTransition>
          </TransitionGroup>
    );
  }
}

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/App.js